import React from "react";
import App from "./App";
import "./index.css";
import { createRoot } from "react-dom/client";
import AppErrorBoundary from "./components/default/AppErrorBoundary";
import { notifyStartupError } from "./monitoring/bugsnag";

import "./i18n";

const loadAnalytics = () => {
  if (
    document.querySelector(
      'script[data-website-id="9551109c-05c7-4b0d-b642-9e3e4c227696"]'
    )
  ) {
    return;
  }

  const analyticsScript = document.createElement("script");
  analyticsScript.defer = true;
  analyticsScript.src = "https://umami.rossjr.dev/script.js";
  analyticsScript.dataset.websiteId = "9551109c-05c7-4b0d-b642-9e3e4c227696";
  document.body.appendChild(analyticsScript);
};

if ("requestIdleCallback" in window) {
  window.requestIdleCallback(loadAnalytics, { timeout: 3000 });
} else {
  window.addEventListener(
    "load",
    () => {
      window.setTimeout(loadAnalytics, 1500);
    },
    { once: true }
  );
}

if (window.__preAppError) {
  notifyStartupError(window.__preAppError);
  delete window.__preAppError;
}

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <AppErrorBoundary>
    <App />
  </AppErrorBoundary>
);
